//频道管理
import React, { useState, useCallback, useEffect, useMemo } from "react"
import { observer } from "mobx-react-lite"
import { StyleSheet } from "~/ui/primitives"
import styled, { useTheme } from "~/ui/styled"
import { TouchableOpacity, FlatList, ScrollView, DeviceEventEmitter } from "~/ui/primitives"
import { useSafeAreaInsets } from "~/ui/safe-area"
import { Tabs } from "~components/Tabs"
import {
  Flex,
  StartFlex,
  ColumnFlex,
  CenterFlex,
  Text,
  BetweenFlex,
  IconFont,
  Button,
} from "~components/El"
import { TextField, MultiLineTextField } from "~components/InputField";
import { ChatPerms } from "~proto"
import { useStores } from "~models"
import { useActiveChat } from "~hooks/useActiveChat"
import { DialogShareContent } from "~components/PopupComponents"
import { Avatar, UploadableAvatar } from "~widgets/avatar"
import useGroupActions from "~hooks/useGroupActions"
import { useModal } from "~hooks/useModal"
import { formatDate, globalToast } from "~utils"
import useNavigation from "~hooks/useNavigation"
import { flexPageContainer, scrollViewFillStyle } from "~/ui/scroll-layout"
// import SlideInput from "../components/SlideInput"

const Container = styled(ColumnFlex)`
  /* height: auto; */
  width: 100%;
  min-height: 0;
  background-color: ${({ theme }) => theme.colors.blockBackground};
  overflow: hidden;
`

const ChatPermsLabel: Record<ChatPerms, string> = {
  [ChatPerms.DEFAULT]: "订阅者",
  [ChatPerms.ADMIN]: "频道主",
  [ChatPerms.SUB_ADMIN]: "管理员"
}

const Header = ({ current }) => {
  const theme = useTheme()
  const { updateGroupTitle, updateGroupAvatar } = useGroupActions()
  const [isEditing, setIsEditing] = useState(false)
  const [groupName, setGroupName] = useState(current.title)

  return (
    <CenterFlex height="auto" width="100%" padding="10px">
      <BetweenFlex
        height={76}
        padding="0 10px"
        gap={theme.space.sm}
        flex={1}
        bg="blockBackground"
        borderRadius="12px"
      >
      <StartFlex height="auto" width="auto" gap={theme.space.lg} minWidth={'max-content'}>
        <UploadableAvatar
          avatar={current.image}
          name={current.title}
          size={56}
          onChange={(result) => {
            current.setImage(result.uri)
            updateGroupAvatar({ chat_id: current.chat_id, image: result.uri, type: current.type })
          }}
        />
        <ColumnFlex height="auto" width="auto"  gap={theme.space.xs}>
          {isEditing ? (
            <TextField
              placeholder="请输入频道名称"
              value={groupName}
              maxLength={20}
              style={{ height: 30 }}
              onChangeText={(text) => setGroupName(text)}
            />
          ) : (
            <Text color="text" fontWeight="600" fontSize={theme.fontSizes.lg}>
              {groupName}
            </Text>
          )}
          <StartFlex height="auto" minWidth={'max-content'} width="auto" gap={theme.space.xs}>
            <IconFont name={"cjql"} color={theme.colors.secondaryText} size={14} />
            <Text minWidth={'max-content'} color="secondaryText">{current?.members?.length || '0'}人订阅</Text>
          </StartFlex>
        </ColumnFlex>
        </StartFlex>
        {current?.isCurrentUserIsAdmin && (
          <StartFlex width="auto" height="auto" minWidth={'max-content'} gap={theme.space.xs}>
            {isEditing ? (
              <>
          
                  <CenterFlex   onClick={() => {
                    updateGroupTitle({ chat_id: current.chat_id, title: groupName, type: current.type})
                    setIsEditing(false)
                  }}  width={30} height={30} borderRadius={15} bg="rgba(7, 193, 96, 0.1)">
                    <IconFont name={"js"} color={"primary"} size={16} />
                  </CenterFlex>

              
                  <CenterFlex   onClick={() => {
                    setIsEditing(false)
                  }} width={30} height={30} borderRadius={15} bg="background">
                    <IconFont name={"close"} color={"secondaryText"} size={14} />
                  </CenterFlex>
              </>
            ) : (
                <CenterFlex   onClick={() => {
                  setIsEditing(true)
                }} width={30} height={30} borderRadius={15} bg="background">
                  <IconFont name={"a-Frame1561999600"} color={"primaryText"} size={16} />
                </CenterFlex>
            )}
          </StartFlex>
        )}
        
      </BetweenFlex>
    </CenterFlex>
  )
}

const ActionItem: React.FC<any> = ({ actionsItem }) => {
  return (
      <CenterFlex   onClick={() => {
        actionsItem.handleClick && actionsItem.handleClick()
      }} width={28} height={28} borderRadius={14} bg={actionsItem.iconBgColor}>
        <IconFont name={actionsItem.icon} color={actionsItem.iconColor} size={14} />
      </CenterFlex>
  )
}

const ChannelMembersItem = observer(({ item, index }: { item: any, index: number }) => {
//   console.log("item", item)
  const theme = useTheme()
  const { chatStore } = useStores()
  const { current } = chatStore
  const { Dialog } = useModal()
  const { setGroupMemberRole, handleRemoveGroupMember } = useGroupActions()
  
  const actions = [
      // {
      //   title: "用户禁言",
      //   icon: index % 2 === 1 ? "a-Frame1561999595" : "Union",
      //   iconColor: index % 2 === 1 ? "#07c160" : "#fa5251",
      //   iconBgColor: index % 2 === 1 ? "rgba(7, 193, 96, 0.1)" : "#fee2e1",
      //   handleClick: () => {
      //     setMessageModal({
      //       visible: true,
      //       extra: {
      //         message: "测试1",
      //         onConfirm: () => {
      //         },
      //         onCancel: () => {
      //         },
      //       },
      //     })
      //   },
      // },
      {
        title: "管理员",
        icon: "a-Frame1561999596",
        iconColor: item.perm === ChatPerms.SUB_ADMIN ? "#07c160" : "#a2a8af",
        iconBgColor: item.perm === ChatPerms.SUB_ADMIN  ? "rgba(7, 193, 96, 0.1)" : "#f7f7f7",
        handleClick: () => {
          Dialog.show({
            title: "温馨提示",
            content: React.createElement(DialogShareContent, {
              content: `确定要${item.perm === ChatPerms.SUB_ADMIN ? "取消" : "任命"} ${item.user?.name} 为管理员吗？`,
              subContent: item.user?.name,
              avatarProps: {
                size: 36,
                name: item.user?.name,
                avatar: item.user?.avatar,
              }
            }),
            onConfirm: () => {
              setGroupMemberRole({
                user_id: item.user_id,
                is_sub_admin: item.perm === ChatPerms.SUB_ADMIN ? false : true,
              },
              (data) => {
                globalToast.show(`${item.perm === ChatPerms.SUB_ADMIN ? "任命" : "取消"}管理员成功`)
              },
              (error) => {
                globalToast.show(error.message || "管理员设置失败")
              }
            )
            },
          })
        },
      },
      {
        title: "移除频道成员",
        icon: "a-Frame1561999598",
        iconColor: index === 1 ? "#07c160" : "#a2a8af",
        iconBgColor: index === 1 ? "rgba(7, 193, 96, 0.1)" : "#f7f7f7",
        handleClick: () => {
          Dialog.show({
            title: "温馨提示",
            content: React.createElement(DialogShareContent, {
              content: `确定要移除 ${item.user?.name} 出频道吗？`,
              subContent: item.user?.name,
              avatarProps: {
                size: 36,
                name: item.user?.name,
                avatar: item.user?.avatar,
              }
            }),
            onConfirm: () => {
              handleRemoveGroupMember({ user_ids: [item.user_id] })
            },
          })
        },
      },
    ]
  return (
    <BetweenFlex minHeight={62} height={'auto'} gap="10px" width="100%" padding="0 10px" mb="10px">
      <Avatar avatar={item.user?.avatar} size={40} name={item.user?.name} />
      <ColumnFlex  gap="6px">
        <BetweenFlex
          gap="10px"
          padding="0 0 10px"
         
          style={{
            borderBottomColor: "#ccc",
            borderBottomWidth: StyleSheet.hairlineWidth,
          }}
        >
          <ColumnFlex height={'auto'} width={'auto'} minWidth={'max-content'} flex={1} gap="2px">
            <StartFlex gap="3px">
              <Text color="text" fontWeight="600" fontSize={theme.fontSizes.lg}>
                {item.user?.name || ''}
              </Text>
              {item.perm === ChatPerms.ADMIN && (<IconFont name="a-Frame1561999599" color="#ff9a35" size={12} />)}
              {item.perm === ChatPerms.SUB_ADMIN && (<IconFont name="a-Frame1561999596" color="#ff9a35" size={12} />)}
              {/* {item.perm === ChatPerms.RED_PACKET_BOT && (<IconFont name="a-Frame1561999597" color="#07c160" size={12} />)}
              {item.perm === ChatPerms.PAYOUT_BOT && (<IconFont name="Frame-1" color="#fa5251" size={12} />)} */}
            </StartFlex>
            <Text color="secondaryText" fontSize={theme.fontSizes.sm}>
              {ChatPermsLabel[item.perm]} · 加入时间 {formatDate(item.created)}
            </Text>
          </ColumnFlex>
          {!(item.perm === ChatPerms.ADMIN) && current.isCurrentUserIsAdmin && (
             <StartFlex height={'auto'}  gap="4px" flexWrap="wrap">
              {actions.map((actionsItem, i) => (
                <ActionItem key={i} actionsItem={actionsItem} item={item} />
              ))}
            </StartFlex>
          )}
        </BetweenFlex>
        <CenterFlex  height={StyleSheet.hairlineWidth} width="100%" bg="#e3e6ec" />
      </ColumnFlex>
    </BetweenFlex>
  )
})
const ChannelMembers = () => {
  const { chatStore } = useStores()
  const insets = useSafeAreaInsets()
  const keyExtractor = useCallback((item, idx) => item.user_id || idx.toString(), [])
  const renderItem = useCallback(
    ({ item, index }) => <ChannelMembersItem item={item} index={index} />,
    []
  )
  return (
    <FlatList
      data={chatStore.currentMembers}
      keyExtractor={keyExtractor}
      contentContainerStyle={{ flexGrow: 1, paddingBottom: insets.bottom + 60 }}
      renderItem={renderItem}
      removeClippedSubviews
      initialNumToRender={12}
      maxToRenderPerBatch={10}
      updateCellsBatchingPeriod={50}
      windowSize={10}
      style={{ flex: 1 }}
    />
  )
}

const ChannelSettings = () => {
  const theme = useTheme()
  const navigation = useNavigation()
  const insets = useSafeAreaInsets()
  const { chatStore } = useStores()
  const { current } = chatStore
  const { joinGameGroup, relatedGameGroup, handleChatAnnouncement } = useGroupActions()
  const [loading, setLoading] = useState(false)
  const [isEditAnnouncement, setIsEditAnnouncement] = useState(false)
  const [announcementInput, setAnnouncementInput] = useState(current?.desc || "")
  const [groupId, setGroupId] = useState("")
  const [real, setReal] = useState(false)
  // console.log(current, 'current')
  const channelChatInfo = current.channelChatInfo
  const linkGroups = current.channelChatInfo?.link_groups || []
  const compensate_bots = current.channelChatInfo?.compensate_bots || [] // 赔付机器人 ID 
  const collect_bots = current.channelChatInfo?.collect_bots || [] // 领包机器人

  useEffect(() => {
    setAnnouncementInput(current?.desc || "")
  }, [current?.desc])

  return (
    <ScrollView
      style={scrollViewFillStyle}
      showsVerticalScrollIndicator={false}
      removeClippedSubviews
      keyboardShouldPersistTaps="handled"
      contentContainerStyle={{
        paddingBottom: insets.bottom + 120,
      }}
    >
      <ColumnFlex height="auto" width="100%" padding="0 10px" gap="12px">
        <BetweenFlex width="100%" height="42px">
          <StartFlex height="auto" minWidth={'max-content'} width="auto" gap="10px">
            <IconFont name="cjql" color={"primary"} size={20} />
            <Text color={theme.colors.text} fontWeight="600" fontSize={theme.fontSizes.lg}>频道简介</Text>
          </StartFlex>
          {current.isCurrentUserIsAdmin && (
            <Button
              onClick={() => {
                setAnnouncementInput(current?.desc || "")
                setIsEditAnnouncement(!isEditAnnouncement)
              }}
              padding="0 10px"
              height="24px"
              bg={isEditAnnouncement ? "#f7f7f7" : "rgba(78, 152, 243, 0.1)"}
              borderRadius="4px"
            >
              <Text color={isEditAnnouncement ? "#a2a8af" : "#4e98f3"} fontSize="12px">
                {isEditAnnouncement ? "取消" : "编辑"}
              </Text>
            </Button>
          )}
          
        </BetweenFlex>
        {isEditAnnouncement ? (
          <>
            <MultiLineTextField
              style={{
                height: 160,
                paddingBottom: 24,
              }}
              placeholder={"请输入频道简介"}
              value={announcementInput}
              maxLength={500}
              onChangeText={(value) => {
                setAnnouncementInput(value)
              }}
            />
            <Button
              width="100%"
              bg="buttonBackground"
              borderRadius="10px"
              height="44px"
              loading={loading}
              onClick={() => {
                setLoading(true)
                handleChatAnnouncement({ chat_id: current.chat_id, desc: announcementInput })
                  .then(() => {
                    globalToast.show("频道简介保存成功")
                    current?.setAnnouncement?.(announcementInput)
                    setIsEditAnnouncement(false)
                  })
                  .catch((error) => {
                    globalToast.show(error?.message || "频道简介保存失败")
                  })
                  .finally(() => {
                    setLoading(false)
                  })
              }}
            >
              <Text color="#fff" fontWeight="600">
                保存
              </Text>
            </Button>
          </>
        ) : (
          <StartFlex width="100%" padding="13px 12px" borderRadius="8px" bg="background">
            <Text color={(current?.desc || "") ? theme.colors.text : theme.colors.secondaryText}>
              {current?.desc || "暂无简介"}
            </Text>
          </StartFlex>
        )}
        <ColumnFlex width="100%">
          <StartFlex width="100%">
            <IconFont name="cbxs" color={theme.colors.primary} size={18} />
            <Text color={theme.colors.text} fontWeight="600" fontSize={theme.fontSizes.lg} ml="10px">关联担保群配置</Text>
          </StartFlex>
          {linkGroups.map((item, index) => (
            <BetweenFlex
              key={index}
              width="100%"
              mt="10px"
              padding="8px 10px"
              borderRadius="8px"
              bg={theme.colors.background}
            >
              <ColumnFlex width="70%">
                <Text color={theme.colors.text} fontWeight="600" fontSize="14px">{item.group_title}</Text>
                <Text color={theme.colors.secondary} fontSize="12px" mt="3px">群ID: {item.group_id}</Text>
              </ColumnFlex>
              <Button
                width="auto"
                height="30px"
                padding="0 10px" 
                borderRadius="6px"
                bg={Boolean(item.is_active) ? theme.colors.primary : theme.colors.warning}
                onClick={() => {
                  relatedGameGroup({
                    channel_id: item.channel_id,
                    group_id: item.group_id,
                    is_active: item.is_active === 0 ? 1 : 0
                  },(data) => {
                    chatStore.onChannelChatInfoLinkGroupUpdated(data)
                    globalToast.show(data.is_active === 1 ? "关联成功" : "取消关联成功")
                  },
                  (error) => {
                    globalToast.show(error?.message || "关联失败")
                  })
                }}
              >
                <Text color={theme.colors.textLight} fontSize="14px">{Boolean(item.is_active) ? "已关联" : "未关联"}</Text>
              </Button>
            </BetweenFlex>
          ))}
          
          <BetweenFlex width="100%" mt="10px">
            <StartFlex flex={1}>
              <TextField
                maxLength={30}
                placeholder="请输入群别名ID"
                value={groupId}
                onChangeText={(text) => setGroupId(text)}
              />
            </StartFlex>
            {/**chat_id: sIFSt3ik0hQt3GH6VFLUO, id: 10*/}
            <Button
              width="60px"
              height="40px"
              ml="10px"
              borderRadius="6px"
              bg={theme.colors.primary}
              disabled={!groupId}
              onClick={() => {
                joinGameGroup(
                  {channel_id: current.id, group_id: groupId},
                  (data) => {
                    globalToast.show("关联成功")
                    // console.log(data, 'data---')
                    setGroupId("")
                    // keep link_groups in sync immediately
                    if (data?.link_groups) {
                      current?.setChannelChatInfo?.({ link_groups: data.link_groups })
                    } else if (data?.group_id) {
                      // minimal optimistic update when backend only returns group_id
                      const next = [
                        ...(current?.channelChatInfo?.link_groups || []),
                        {
                          channel_id: current.id,
                          group_id: data.group_id,
                          group_title: data.group_title || groupId,
                          is_active: 0,
                        },
                      ]
                      current?.setChannelChatInfo?.({ link_groups: next })
                    }
                    navigation.goBack()
                  },
                  (error) => {
                    // console.log(error.message, 'error')
                    globalToast.show(error?.message || "添加失败")
                  }
                )
              }}
            >
              <Text color={theme.colors.textLight} fontSize="14px">添加</Text>
            </Button>
          </BetweenFlex>
        </ColumnFlex>
        <ColumnFlex width="100%">
          <StartFlex width="100%">
            <IconFont name="cbxs" color={theme.colors.primary} size={18} />
            <Text color={theme.colors.text} fontWeight="600" fontSize={theme.fontSizes.lg} ml="10px">担保游戏群信息</Text>
          </StartFlex>
          <ColumnFlex
            width="100%"
            mt="10px"
            padding="8px 10px"
            borderRadius="8px"
            bg={theme.colors.background}
          >
            <ColumnFlex width="100%">
              <Text color={theme.colors.text} fontWeight="600" fontSize="14px">赔付机器人账号</Text>
              <Text color={theme.colors.secondary} fontSize="12px" mt="3px">当前担保群中负责游戏赔付的机器人账号</Text>
            </ColumnFlex>
            <StartFlex mt="8px" gap="5px">
              {compensate_bots.map((item, index) => (
                <CenterFlex key={index} width="40px" height="20px" borderRadius="10px" bg="#ffe4e4">
                  <Text color="#9a3412" fontSize="12px">{item}</Text>
                </CenterFlex>
              ))}
            </StartFlex>
          </ColumnFlex>
          <ColumnFlex
            width="100%"
            mt="10px"
            padding="8px 10px"
            borderRadius="8px"
            bg={theme.colors.background}
          >
            <ColumnFlex width="100%">
              <Text color={theme.colors.text} fontWeight="600" fontSize="14px">领红包机器人账号</Text>
              <Text color={theme.colors.secondary} fontSize="12px" mt="3px">当前担保群中负责领取红包的机器人账号</Text>
            </ColumnFlex>
            <StartFlex mt="8px" gap="5px">
              {collect_bots.map((item, index) => (
                <CenterFlex key={index} width="40px" height="20px" borderRadius="10px" bg="#ffe4e4">
                  <Text color="#9a3412" fontSize="12px">{item}</Text>
                </CenterFlex>
              ))}
            </StartFlex>
          </ColumnFlex>
        </ColumnFlex>
        <ColumnFlex width="100%">
          <StartFlex width="100%">
            <IconFont name="cbxs" color={theme.colors.primary} size={18} />
            <Text color={theme.colors.text} fontWeight="600" fontSize={theme.fontSizes.lg} ml="10px">占股模式</Text>
          </StartFlex>
          <Flex
            flexDirection="column"
            width="100%"
            mt="10px"
            padding="10px 12px"
            borderRadius="8px"
            borderWidth={StyleSheet.hairlineWidth}
            borderColor="#fff1ed"
            borderStyle="solid"
            bg="#fff8ef"
          >
            <Text color="#9a3412" fontSize={14} fontWeight={600}>占股模式已启用</Text>
            <Flex flexDirection="column" width="100%" mt="5px">
              <Text color="#9a3412" fontSize="12px" lineHeight="18px">
                官方将按比例提供资金支持，共同承担风险
              </Text>
            </Flex>
          </Flex>
          <Flex
            flexDirection="column"
            width="100%"
            mt="10px"
            padding="10px 12px"
            borderRadius="8px"
            borderWidth={StyleSheet.hairlineWidth}
            borderColor="#fff1ed"
            borderStyle="solid"
            bg="#fff8ef"
          >
            <Text color="#9a3412" fontSize={14} fontWeight={600}>占股比例设置</Text>
            <Flex flexDirection="column" width="100%" mt="5px">
              {/* <Text color="#9a3412" fontSize="12px" lineHeight="18px">
                您的占股比例: {channelChatInfo?.owner_percentage || '0'}%
              </Text>
              <SlideInput step={1} value={channelChatInfo?.owner_percentage ? Number(channelChatInfo?.owner_percentage) : 0} disabled={true} onChange={(v) => {}} /> */}
              <BetweenFlex width="100%" gap="10px" mt="10px">
                <ColumnFlex
                  flex={1}
                  padding="10px"
                  borderWidth={StyleSheet.hairlineWidth}
                  borderColor="#eee"
                  borderStyle="solid"
                  borderRadius="2px"
                  bg="#fff"
                >
                  <Text color="#9a3412" fontSize={14} fontWeight={600}>您的占股</Text>
                  <Text color="#9a3412" fontSize={16} fontWeight={600}>{channelChatInfo?.owner_percentage || '0'}%</Text>
                </ColumnFlex>
                <ColumnFlex
                  flex={1}
                  padding="10px"
                  borderWidth={StyleSheet.hairlineWidth}
                  borderColor="#eee"
                  borderStyle="solid"
                  borderRadius="2px"
                  bg="#fff"
                >
                  <Text color="#9a3412" fontSize={14} fontWeight={600}>官方占股</Text>
                  <Text color="#9a3412" fontSize={16} fontWeight={600}>{channelChatInfo?.official_percentage || '0'}%</Text>
                </ColumnFlex>
              </BetweenFlex>
              <Flex flexDirection="column" width="100%" mt="5px">
                <Text color="#9a3412" fontSize="12px" lineHeight="18px">
                  • 您上压资金时，官方将按比例同步投入
                </Text>
                <Text color="#9a3412" fontSize="12px" lineHeight="18px">
                  • 您下压资金时，官方资金也会按比例减少
                </Text>
                <Text color="#9a3412" fontSize="12px" lineHeight="18px">
                  • 关联群的赔率等设置需要官方后台配置
                </Text>
                <Text color="#9a3412" fontSize="12px" lineHeight="18px">
                  • 占股比例设置成功后不可修改
                </Text>
            </Flex>
            </Flex>
          </Flex>
        </ColumnFlex>
        <ColumnFlex width="100%">
          <BetweenFlex width="100%">
            <StartFlex width="auto">
              <IconFont name="cbxs" color={theme.colors.primary} size={18} />
              <Text color={theme.colors.text} fontWeight="600" fontSize={theme.fontSizes.lg} ml="10px">担保资金管理</Text>
            </StartFlex>
            <Button
              flexDirection="row"
              width="auto"
              height="auto"
              onClick={() => setReal(!real)}
            >
              <IconFont name={real ? "yincang" : "xszxzt"} color={theme.colors.primaryText} size={real ? 12 : 16} />
              <Text color={theme.colors.primaryText} fontSize="14px" ml="5px">{real ? "隐藏" : "显示"}真实</Text>
            </Button>
          </BetweenFlex>
          <ColumnFlex width="100%" mt="10px" padding="0 10px" borderRadius="8px" bg={theme.colors.background}>
            <BetweenFlex
              width="100%"
              padding="10px 0"
            >
              <Text color={theme.colors.secondary} fontSize="14px">当前担保资金</Text>
              <Text color={theme.colors.primary} fontSize="14px">¥{channelChatInfo?.official_balance_cny || '0'}</Text>
            </BetweenFlex>
            {real && (
              <BetweenFlex
                width="100%"
                padding="10px 0"
                borderTopWidth={StyleSheet.hairlineWidth}
                borderTopColor={theme.colors.border}
                borderTopStyle="solid"
              >
                <Text color={theme.colors.secondary} fontSize="14px">真实担保资金</Text>
                <Text color={theme.colors.primaryText} fontSize="14px">¥{channelChatInfo?.total_amount || '0'}</Text>
              </BetweenFlex>
            )}
          </ColumnFlex>
          <Flex
            flexDirection="column"
            width="100%"
            mt="10px"
            padding="10px 12px"
            borderRadius="8px"
            borderWidth={StyleSheet.hairlineWidth}
            borderColor="#fff1ed"
            borderStyle="solid"
            bg="#fff8ef"
          >
            <Text color="#9a3412" fontSize={14} fontWeight={600}>资金流转规则</Text>
            <Flex flexDirection="column" width="100%" mt="5px">
              <Text color="#9a3412" fontSize="12px" lineHeight="18px">
                • 游戏下注赔付：自动扣除担保资金
              </Text>
              <Text color="#9a3412" fontSize="12px" lineHeight="18px">
                • 红包收益：自动增加担保资金
              </Text>
              <Text color="#9a3412" fontSize="12px" lineHeight="18px">
                • 超出上压最高金额时，普通用户只能看到上压最高担保资金
              </Text>
              <Text color="#9a3412" fontSize="12px" lineHeight="18px">
                • 只有频道主能查看真实超出的担保资金
              </Text>
            </Flex>
          </Flex>
        </ColumnFlex>
      </ColumnFlex>
    </ScrollView>
  )
}

const ChannelMembersObserver = observer(ChannelMembers)
const ChannelSettingsObserver = observer(ChannelSettings)

const TAB_MAP = {
  "频道成员": ChannelMembersObserver,
  "频道设置": ChannelSettingsObserver,
}
const tabs: string[] = ["频道成员", "频道设置"]
const ChannelChatManagement: React.FC<any> = () => {
  const { chatStore, apiStore } = useStores()
  const { chat: current } = useActiveChat()
  const [tab, setTab] = useState("频道成员")
  const onTabPress = (item: string) => {
    setTab(item)
  }
  const Com = useMemo(() => TAB_MAP[tab], [tab])

  const fetchChannelChatInfo = useCallback(async () => {
    if (!current?.id) return
    try {
      const res = await apiStore.getChannelGroupSettingInfo({
        chat_id: current.id,
        type: 2,
      })
      if (res?.data) {
        current.setChannelChatInfo(res.data)
      }
    } catch {
      // ignore
    }
  }, [apiStore, current])

  useEffect(() => {
    void fetchChannelChatInfo()
  }, [fetchChannelChatInfo])

  useEffect(() => {
    const sub = DeviceEventEmitter.addListener("RefreshChannelChatInfo", () => {
      void fetchChannelChatInfo()
    })
    return () => sub.remove()
  }, [fetchChannelChatInfo])

  if (!current) return null

  return (
    <Container>
      <Header current={current}/>
      <ColumnFlex
        flex={1}
        height="auto"
        minHeight={0}
        padding="10px 0"
        borderRadius="12px 12px 0 0"
        bg="blockBackground"
        gap="10px"
        overflow="hidden"
      >
        <CenterFlex height="auto"padding="0 10px">
          <Tabs
            height={36}
            tabs={tabs}
            active={tab}
            onChange={(item) => onTabPress(typeof item === "string" ? item : item.value)}
          />
        </CenterFlex>
        <Com />
      </ColumnFlex>
    </Container>
  )
}

export default observer(ChannelChatManagement)
